import { classNames } from '@fullstory/util/fmt';
import React, { ReactNode } from 'react';
import { identifyComponent } from '../../util';
import { Box } from '../Box';
import { Flex } from '../Flex';
import css from './index.module.scss';

export interface AppBarProps {
  height?: number;
  left?: ReactNode;
  middle?: ReactNode;
  right?: ReactNode;
  top?: ReactNode;
}

export const AppBar: React.FC<AppBarProps> = ({
  height = 80,
  left = null,
  middle = null,
  right = null,
  top = null,
}) => (
  <Box data-component="AppBar" {...identifyComponent('app-bar')}>
    {top}
    <Flex alignItems="center" justifyContent="flex-start" style={{ height }}>
      <Box className={classNames(css.box, css.left)}>{left}</Box>
      <Box className={classNames(css.box, css.middle)} collapsible>
        {middle}
      </Box>
      <Box className={classNames(css.box, css.right)}>{right}</Box>
    </Flex>
  </Box>
);
